import { SET_PILL_OPTIONS_SOURCE, SET_PILL_OPTIONS_SEARCH_STRING, FETCH_PILL_OPTIONS_STUB, FETCH_PILL_OPTIONS_STUB_DONE, FETCH_PILL_OPTIONS_STUB_ERR, SET_PILL_OPTIONS_STUB, FETCH_PILL_OPTIONS_NAME, FETCH_PILL_OPTIONS_NAME_DONE, FETCH_PILL_OPTIONS_NAME_ERR, SET_PILL_OPTIONS_NAME, FETCH_PILL_OPTIONS_FORM, FETCH_PILL_OPTIONS_FORM_DONE, FETCH_PILL_OPTIONS_FORM_ERR, SET_PILL_OPTIONS_FORM, FETCH_PILL_OPTIONS_STRENGTH, FETCH_PILL_OPTIONS_STRENGTH_DONE, FETCH_PILL_OPTIONS_STRENGTH_ERR, SET_PILL_OPTIONS_STRENGTH, SET_PILL_OPTIONS_TYPE, SET_PILL_OPTIONS_EXPIRES, SET_PILL_OPTIONS_SCHEDULES, SET_PILL_OPTIONS_STORED_IN_HERO, RESET_PILL_OPTIONS } from './actionTypes';
export const setPillOptionsSource = (data) => ({
    type: SET_PILL_OPTIONS_SOURCE,
    data
});
export const setPillOptionsSearchString = (data) => ({
    type: SET_PILL_OPTIONS_SEARCH_STRING,
    data
});
export const fetchPillOptionsStub = (data) => ({
    type: FETCH_PILL_OPTIONS_STUB,
    data
});
export const fetchPillOptionsStubDone = (data) => ({
    type: FETCH_PILL_OPTIONS_STUB_DONE,
    data
});
export const fetchPillOptionsStubError = (data) => ({
    type: FETCH_PILL_OPTIONS_STUB_ERR,
    errorMessage: data
});
export const setPillOptionsStub = (data) => ({
    type: SET_PILL_OPTIONS_STUB,
    data
});
export const fetchPillOptionsName = (data) => ({
    type: FETCH_PILL_OPTIONS_NAME,
    data
});
export const fetchPillOptionsNameDone = (data) => ({
    type: FETCH_PILL_OPTIONS_NAME_DONE,
    data
});
export const fetchPillOptionsNameError = (data) => ({
    type: FETCH_PILL_OPTIONS_NAME_ERR,
    errorMessage: data
});
export const setPillOptionsName = (data) => ({
    type: SET_PILL_OPTIONS_NAME,
    data
});
export const fetchPillOptionsForm = (data) => ({
    type: FETCH_PILL_OPTIONS_FORM,
    data
});
export const fetchPillOptionsFormDone = (data) => ({
    type: FETCH_PILL_OPTIONS_FORM_DONE,
    data
});
export const fetchPillOptionsFormError = (data) => ({
    type: FETCH_PILL_OPTIONS_FORM_ERR,
    errorMessage: data
});
export const setPillOptionsForm = (data) => ({
    type: SET_PILL_OPTIONS_FORM,
    data
});
export const fetchPillOptionsStrength = (data) => ({
    type: FETCH_PILL_OPTIONS_STRENGTH,
    data
});
export const fetchPillOptionsStrengthDone = (data) => ({
    type: FETCH_PILL_OPTIONS_STRENGTH_DONE,
    data
});
export const fetchPillOptionsStrengthError = (data) => ({
    type: FETCH_PILL_OPTIONS_STRENGTH_ERR,
    errorMessage: data
});
export const setPillOptionsStrength = (data) => ({
    type: SET_PILL_OPTIONS_STRENGTH,
    data
});
export const setPillOptionsType = (data) => ({
    type: SET_PILL_OPTIONS_TYPE,
    data
});
export const setPillOptionsExpires = (data) => ({
    type: SET_PILL_OPTIONS_EXPIRES,
    data
});
export const setPillOptionsSchedules = (data) => ({
    type: SET_PILL_OPTIONS_SCHEDULES,
    data
});
export const setPillOptionsStoredInHero = (data) => ({
    type: SET_PILL_OPTIONS_STORED_IN_HERO,
    data
});
export const resetPillOptions = () => ({
    type: RESET_PILL_OPTIONS
});
//# sourceMappingURL=actionCreators.js.map